import { mergeDeep } from './merge-deep';

export function withDefaults<T, D extends { [key in keyof T]?: T[key] }>(obj: T, defaults: D): D & T {
    return mergeDeep<any>(defaults, obj) as D & T;
}
